import { getEmptySelectionSet } from '.';

export const getEmptySelectorState = (): StatementSelectorState => ({
    regionFilter: 'standard',
    selectionSets: {
        international: getEmptySelectionSet(),
        standard: getEmptySelectionSet(),
        unfiltered: getEmptySelectionSet(),
    },
});
